<template>
  <div :style="style" :class="['animation-vue', insertClassName]" :id="id"></div>
</template>

<script>
export default {
  props: ['className', 'path', 'loop', 'autoplay'],

  data() {
    return {
      id: 'animation-vue-' + this._uid,
      animationZIndex: 9999,
      insertClassName: this.className
    }
  },

  computed: {
    style() {
      return {
        /* Hack to increase size of lottie */
        position: "absolute",
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
          zIndex: this.animationZIndex
      }
    }
  },

  mounted() {
    // Lottie is currently a global variable. Should probably be moved to an import/require
    lottie.loadAnimation({
      container: document.getElementById(this.id),
      renderer: 'svg',
      loop: this.loop,
      autoplay: this.autoplay,
      path: this.path,
    });

    setTimeout(() => {
        this.animationZIndex = -1;
    }, 2000);
  },
}
</script>